const resolveApiBase = function () {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  if (typeof process !== "undefined" && process.env?.API_BASE_URL) {
    return process.env.API_BASE_URL;
  }

  return "";
};

const API_BASE = resolveApiBase();

export const API_URL_ADDRESS = `${API_BASE}/api/v1/storefront/customers/address`;

export const API_URL_ADDRESS_LOOKUP = `${API_BASE}/api/v1/storefront/address-lookup`;

export const API_URL_PRODUCT = `${API_BASE}/api/v1/storefront/products/`;

export const API_URL_CART = `${API_BASE}/api/v1/storefront/order/cart`;

export const API_URL_OPENING = `${API_BASE}/api/v1/storefront/store-locations/`;

export const API_URL_PAST_ORDERS = `${API_BASE}/api/v1/storefront/customers/past-orders`;

export const API_URL_ORDER = `${API_BASE}/api/v1/storefront/order`;

export const API_URL_CHECKOUT_SESSION = `${API_BASE}/api/v1/storefront/order/checkout-session`;

export const API_URL_CURRENT_ORDERS = `${API_BASE}/api/v1/storefront/orders/`;

export const API_URL_CUSTOMERINFO = `${API_BASE}/api/v1/storefront/customers/infos`;

export const TEMP_IMG =
  "https://mealboxassets.s3.us-east-2.amazonaws.com/images/gray.jpg";
export const TIMEOUT_SEC = 10;

export const SENTRY_DSN =
  "https://82d8ae79f99deb7418db622eec35d90c@o4509940455112704.ingest.us.sentry.io/4509940491354112";

const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

// Setting up service API
export const requestOptionsGet = {
  credentials: "include",
  headers: myHeaders,
  method: "GET",
};

export const requestOptionsPost = {
  body: undefined,
  credentials: "include",
  headers: myHeaders,
  method: "POST",
};

export const requestOptionsPut = {
  body: undefined,
  credentials: "include",
  headers: myHeaders,
  method: "PUT",
};
